export default function Pricing() {
  const scrollTo = (id: string) => {
    const el = document.getElementById(id);
    if (el) {
      const y = el.getBoundingClientRect().top + window.scrollY - 72;
      window.scrollTo({ top: y, behavior: "smooth" });
    }
  };

  return (
    <section id="pricing" className="w-full py-24 md:py-32 bg-background-50">
      <div className="w-full max-w-6xl mx-auto px-6 md:px-10">
        <div className="mb-14 md:mb-20 max-w-2xl">
          <div className="flex items-center gap-3 mb-4">
            <div className="w-8 h-[1px] bg-primary-500" />
            <span className="text-[11px] tracking-[0.35em] text-primary-500 uppercase">Pricing</span>
          </div>
          <h4 className="font-heading text-3xl md:text-4xl text-foreground-900 leading-snug mb-6">
            <a href="#pricing" className="cursor-pointer">料金</a>
          </h4>
          <p className="text-foreground-600 text-sm md:text-base leading-relaxed">
            原因究明・改善設計費と成果報酬を組み合わせた、シンプルな体系です。
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-12 gap-6">
          <div className="lg:col-span-7 bg-primary-500 text-background-50 rounded-lg p-8 md:p-12 relative overflow-hidden">
            <div className="absolute -right-16 -bottom-16 w-64 h-64 rounded-full bg-primary-400/30 blur-2xl pointer-events-none" />
            <div className="relative">
              <div className="flex items-center gap-3 mb-6">
                <div className="w-8 h-[1px] bg-accent-300" />
                <span className="text-[11px] tracking-[0.3em] text-accent-100 uppercase">Fee Structure</span>
              </div>
              <h5 className="font-heading text-2xl md:text-3xl mb-8 leading-snug">
                原因究明・改善設計 + 成果連動報酬
              </h5>

              <div className="space-y-6 mb-10">
                <div className="pb-6 border-b border-background-50/20">
                  <div className="flex items-baseline justify-between gap-4 flex-wrap">
                    <div>
                      <div className="text-xs tracking-[0.2em] text-accent-100 mb-2">FIXED FEE</div>
                      <div className="font-heading text-lg">原因究明・改善設計費</div>
                    </div>
                    <div className="font-heading text-3xl md:text-4xl">
                      ¥200,000<span className="text-sm ml-1 text-background-200">/ 案件</span>
                    </div>
                  </div>
                </div>
                <div>
                  <div className="flex items-baseline justify-between gap-4 flex-wrap">
                    <div>
                      <div className="text-xs tracking-[0.2em] text-accent-100 mb-2">SUCCESS FEE</div>
                      <div className="font-heading text-lg">成果報酬</div>
                    </div>
                    <div className="font-heading text-3xl md:text-4xl">
                      改善額の 10<span className="text-lg ml-1">%</span>
                    </div>
                  </div>
                  <p className="text-xs text-background-200 mt-3 leading-relaxed">
                    ※ 原因究明・改善設計費 20万円を控除した残額のみご請求します。
                  </p>
                </div>
              </div>

              <button
                onClick={() => scrollTo("contact")}
                className="inline-flex items-center gap-2 px-6 py-3 bg-background-50 text-primary-700 hover:bg-background-100 text-sm font-medium rounded-md transition-colors whitespace-nowrap cursor-pointer"
              >
                <i className="ri-mail-send-line"></i>
                まずはお問い合わせ
              </button>
            </div>
          </div>

          <div className="lg:col-span-5 flex flex-col gap-6">
            {[
              {
                icon: "ri-shake-hands-line",
                title: "改善効果が確認できない場合、成果報酬は発生しません",
                desc: "原因究明・改善設計費20万円は、調査・設計業務の対価として発生します。事前に合意した評価方法で改善効果が確認できた場合のみ、成果報酬をご請求します。",
              },
              {
                icon: "ri-file-shield-2-line",
                title: "NDA対応可能",
                desc: "必要に応じて秘密保持契約を締結。技術情報・工程情報の取り扱いには十分配慮します。",
              },
              {
                icon: "ri-time-line",
                title: "スケジュール・条件は事前に確認",
                desc: "現場確認、必要な検証、データの有無などを確認したうえで、対応可能かどうか、進め方、想定期間を事前にお伝えします。",
              },
            ].map((b) => (
              <div
                key={b.title}
                className="bg-background-100 border border-background-200 rounded-lg p-6 flex gap-4"
              >
                <div className="w-10 h-10 shrink-0 flex items-center justify-center rounded-md bg-accent-100 text-accent-700">
                  <i className={`${b.icon} text-base`}></i>
                </div>
                <div className="min-w-0">
                  <h6 className="font-heading text-base text-foreground-900 mb-1">{b.title}</h6>
                  <p className="text-xs md:text-sm text-foreground-600 leading-relaxed">{b.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}